module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover-box', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction
    }
  }, [_c('single-stepper-range', {
    attrs: {
      "attribute": _vm.attribute
    },
    on: {
      "select": _vm.selectAttribute
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-556fde64"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/SingleStepperPopover.vue
// module id = 1906
// module chunks = 0